export default "__VITE_ASSET__DUhgdQ08__"